import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    const formData = new FormData(event.currentTarget);
    const submittedEmail = String(formData.get('email') || email).trim();
    const submittedPassword = String(formData.get('password') || password);
    try {
      await login(submittedEmail, submittedPassword);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <section className="auth-showcase login-showcase">
        <div className="auth-showcase-backdrop"></div>
        <div className="auth-showcase-content">
          <span className="showcase-badge">Canli Futbol Terminali</span>
          <img className="auth-logo login-hero-logo" src="/tahminarena-logo.png" alt="TahminArena" />
          <h1>Premium futbol zekasi daha guclu bir vitrinde.</h1>
          <p>
            Canli AI yorumlari, premium kupon posterleri ve mac takibi
            tek merkezde bulusun.
          </p>

          <div className="showcase-points">
            <div className="showcase-point">
              <span className="point-dot"></span>
              <span>Canli maclarda premium AI yorum katmani</span>
            </div>
            <div className="showcase-point">
              <span className="point-dot"></span>
              <span>Gunun en populer maclari ve premium kupon vitrini</span>
            </div>
            <div className="showcase-point">
              <span className="point-dot"></span>
              <span>Guclu olasilik yorumlari ve secili premium senaryolar</span>
            </div>
          </div>
        </div>
      </section>

      <section className="auth-card login-form-card premium-login-card">
        <div className="auth-card-top">
          <span className="auth-kicker">Giris</span>
          <h2>TahminArena hesabiniza girin</h2>
          <p>Canli maclar, premium kuponlar ve AI tahmin odasi burada.</p>
        </div>

        {error ? <div className="error">{error}</div> : null}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-posta</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              onInput={(event) => setEmail(event.currentTarget.value)}
              placeholder="E-posta adresinizi girin"
              autoComplete="username"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck="false"
              required
            />
          </div>

          <div className="form-group">
            <label>Sifre</label>
            <input
              type="password"
              name="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              onInput={(event) => setPassword(event.currentTarget.value)}
              placeholder="Sifrenizi girin"
              autoComplete="current-password"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck="false"
              required
            />
          </div>

          <div className="login-action-row">
            <button type="submit" className="btn-primary" disabled={submitting}>
              {submitting ? 'Giris yapiliyor...' : 'Giris Yap'}
            </button>
          </div>
        </form>

        <p>Hesabiniz yok mu? <Link to="/register">Kayit Ol</Link></p>
      </section>
    </div>
  );
};

export default Login;
